
















































































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../lib/ajax'
import AbpBase from '../../lib/abpbase'
@Component
export default class Home extends AbpBase  {
    initData:any = {
        homePageStatistic: {},
        homePageFlow: [],
        homePageUserNotification: [],
        noticeList: []
    }
    //统计
    GetHomePageStatistic() {
        Ajax.post('/api/services/app/Statistic/HomePageStatisticAsync').then((res:any)=>{
            this.initData.homePageStatistic = res.data.result;
        })
    }
    //待办流程
    GetHomePageFlow() {
        Ajax.post('/api/services/app/Statistic/HomePageFlowAsync').then((res:any)=>{
            this.initData.homePageFlow = res.data.result.items;
        })
    }
    //消息列表
    async GetNotice() {
        await this.$store.dispatch('app/GetHomePageUserNotification');
        this.initData.noticeList = this.$store.state.app.noticeList;
    }
    //工作流界面
    ToWorkFlow(){
        this.$router.push({name: 'backlogWait'});
    }
    //快捷跳转
    ToPage(name:string){
        this.$router.push({
            name: name
        });
    }
    //消息弹窗
    ShowMessage(data:any){
        this.$Modal.info({
            title: data.title,
            content: data.description
        });
    }
    async mounted(){
        await this.GetHomePageStatistic();
        await this.GetHomePageFlow();
        await this.GetNotice();
    }
}
